/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  actionCMD,
  CMDReq,
} from '..';
import {
  serializeactionCMD,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface SendCommandAdvancedInput {
  deviceId: string;
  action: actionCMD;
  transactionId?: string;
}
const build = (_query: DocumentNode, input: SendCommandAdvancedInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.deviceId !== undefined ? `$deviceId: String = ${JSON.stringify(input.deviceId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.action !== undefined ? `$action: actionCMD = ${serializeactionCMD(input.action)}, ` : '' ) + ``+
    ( input.transactionId !== undefined ? `$transactionId: String = ${JSON.stringify(input.transactionId).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    sendCommandAdvanced(
      ${ input.deviceId !== undefined ? 'deviceId: $deviceId,' : '' } 
      ${ input.action !== undefined ? 'action: $action,' : '' } 
      ${ input.transactionId !== undefined ? 'transactionId: $transactionId,' : '' }
    ){
      ...cmdreq
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class SendCommandAdvancedMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment cmdreq on CMDReq { ... }
   */
  async execute(_query: DocumentNode, input: SendCommandAdvancedInput): Promise<apollo.FetchResult< { sendCommandAdvanced: Partial<CMDReq> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ sendCommandAdvanced: Partial<CMDReq> }>({ mutation: build(_query, input) });
  }
}
